import React, { Component } from "react"
import ValidationTextarea from '../ValidationTextarea/clauseType'

import $ from 'jquery'

class CapitalDeces extends Component {
  state = {
    beneficiaireCapitalDecesOtherClause: '',
    beneficiaireCapitalDecesOtherClauseAuthorize: false,
    applyDisabled: true,
  }
  componentDidMount() {
    this.setState({ beneficiaireCapitalDecesOtherClauseAuthorize: false})
  }
  handleCheckboxFirstChange = (event, beneficiaire, position) => {
    $('input[type="radio"]').on('change', function() {
      $('input[name="' + this.name + '"]').not(this).prop('checked', false);
    });
    if (event.target.checked) {
      this.props.checkFormValid("clause-type-" + position, true)

      this.setState(
        (prevState, props) => {
        return { beneficiaireCapitalDecesOtherClauseAuthorize: false, applyDisabled: true }
      }, () => this.applyClause(beneficiaire))
    }
  }
  handleCheckboxSecondChange = (event, beneficiaire, position) => {
    $('input[type="radio"]').on('change', function() {
      $('input[name="' + this.name + '"]').not(this).prop('checked', false);
    });
    if (event.target.checked) {
      this.props.checkFormValid("clause-type-" + position, !!this.beneficiaireCapitalDecesOtherClause)

      this.setState(
        (prevState, props) => {
        return { beneficiaireCapitalDecesOtherClauseAuthorize: true, applyDisabled: false }
      }, () => this.applyClause(beneficiaire))
    }
  }

  applyClause = (beneficiaire) => {
    const { beneficiaireCapitalDecesOtherClauseAuthorize, beneficiaireCapitalDecesOtherClause } = this.state
    let capitalDecesClauseDefault = `Mon conjoint non divorcé, non séparé par un jugement définitif, à défaut mes enfants survivants par
    parts égales entre eux, à défaut mes parents par parts égales entre eux ou au survivant d’entre eux, à
    défaut mes héritiers par parts égales entre eux.`

    if (beneficiaireCapitalDecesOtherClauseAuthorize) {
      this.props.checkCapitalDeces(beneficiaire._id, {clause: false, clauseValue: beneficiaireCapitalDecesOtherClause})
    }else {
      this.props.checkCapitalDeces(beneficiaire._id, {clause: true, clauseValue: capitalDecesClauseDefault})
    }
  }
  handleOnError = (event, errorPayload, position) => {
    let err = errorPayload;
    this.setState((prev, props) => {
      prev.formValid = prev.beneficiaireCapitalDecesOtherClauseAuthorize ? !err.hasError  : true;
      this.props.checkFormValid("clause-type-" + position, prev.formValid)
      return { formValid: prev.formValid };
    });
  }
  handleChangeOtherClauseType = (event, errorPayload, beneficiaire, position) => {
    let err = errorPayload;
    let value = event.target.value;
    this.setState((prev, props) => {
      prev.formValid = prev.beneficiaireCapitalDecesOtherClauseAuthorize ? !err.hasError  : true;
      this.props.checkFormValid("clause-type-" + position, prev.formValid)
      return { formValid: prev.formValid, beneficiaireCapitalDecesOtherClause: value };
    }, () => this.applyClause(beneficiaire));
  }

  render() {
    const {beneficiaires} = this.props
    const {beneficiaireCapitalDecesOtherClauseAuthorize, applyDisabled} = this.state
    let capitalDecesClauseDefault = `Mon conjoint non divorcé, non séparé par un jugement définitif, à défaut mes enfants survivants par
    parts égales entre eux, à défaut mes parents par parts égales entre eux ou au survivant d’entre eux, à
    défaut mes héritiers par parts égales entre eux.`

    return (
    <div className='aps-capital-deces'>
      {beneficiaires.map((beneficiaire, i) => (
        <div key={i}>
          <hr/>
          <p className="uk-text-bold aps-capital-deces-name">{beneficiaire.lastname} {beneficiaire.firstname}</p>
          <hr/>
          <div className="uk-flex aps-capital-deces-input-container">
            <div>
              <div className="aps-capital-deces-answers-checkbox-content-no-editable">
                <label className="aps-questionnaire-answers-label aps-capital-deces-answers-checkbox-content-text">
                  <input
                    name={`${beneficiaire._id}[]`}
                    className="uk-radio aps-questionnaire-answers-radio"
                    type="radio"
                    defaultChecked={beneficiaire.capitalDecesClauseType ? beneficiaire.capitalDecesClauseType.clause : true}
                    onChange={(event) => this.handleCheckboxFirstChange(event, beneficiaire, i)}
                  />
                  Clause type :
                </label>
              </div>
              </div>
              <div className="uk-text-justify capital-deces-txt-no-editable" style={{fontStyle: "italic"}}>
                {capitalDecesClauseDefault}
              </div>
          </div>
          <div className="aps-capital-deces-answers-checkbox-content-text">
            Ou
          </div>
          <div className="uk-flex aps-capital-deces-input-container">
            <span className="aps-capital-deces-answers-checkbox-content">
              <label className="aps-questionnaire-answers-label aps-capital-deces-answers-checkbox-content-text">
                {beneficiaire.capitalDecesClauseType
                  ?
                    <input
                      name={`${beneficiaire._id}[]`}
                      className="uk-radio aps-questionnaire-answers-radio"
                      type="radio"
                      defaultChecked={beneficiaire.capitalDecesClauseType.clause ? false : true}
                      onChange={(event) => this.handleCheckboxSecondChange(event, beneficiaire, i)}
                    />
                  :
                    <input
                      name={`${beneficiaire._id}[]`}
                      className="uk-radio aps-questionnaire-answers-radio"
                      type="radio"
                      defaultChecked={false}
                      onChange={(event) => this.handleCheckboxSecondChange(event, beneficiaire, i)}
                    />
                }
                Autre clause :
              </label>
            </span>
                <ValidationTextarea
                  rows="7"
                  disabledEdit={applyDisabled}
                  beneficiaireCapitalDecesOtherClauseAuthorize={beneficiaireCapitalDecesOtherClauseAuthorize}
                  onBlur={(errorPayload, event) =>this.handleOnError(event, errorPayload, i)}
                  onChange={(errorPayload, event) => this.handleChangeOtherClauseType(event, errorPayload, beneficiaire, i)}
                  defaultValue={beneficiaire.capitalDecesClauseType
                    ? beneficiaire.capitalDecesClauseType.clause ? "" : beneficiaire.capitalDecesClauseType.clauseValue
                    : ""
                  }
                />
          </div>
        </div>
      ))}
    </div>);
  }
}
export default CapitalDeces



// WEBPACK FOOTER //
// ./src/components/CapitalDeces/index.js